import { axios } from '@/utils/request'

const api = {
    options: '/adminapi/caipan/options',
    getApplyList: '/adminapi/caipan/shengCpManageList',
    manageEdit: '/adminapi/caipan/shengCpManageEdit',
    getGuoApplyList: '/adminapi/caipan/guoCpManageList',
    getMemberList: '/adminapi/caipan/shengCpList',
    refreshCert: '/adminapi/caipan/refreshCert',
    getGuoMemberList: '/adminapi/caipan/guoCpList',
    checkShengMemberOK: '/adminapi/caipan/checkShengMemberOK',
    checkGuoMemberOK: '/adminapi/caipan/checkGuoMemberOK',
    shengcpApply: '/adminapi/caipan/shengcpApply',
    guocpApply: '/adminapi/caipan/guocpApply',
    getShengShenheUrls: '/adminapi/caipan/getShengShenheUrls',
    getGuoShenheUrls: '/adminapi/caipan/getGuoShenheUrls',
    shengapplydetail: '/adminapi/caipan/shengapplydetail',
    shengApplyDelete: '/adminapi/caipan/shengApplyDelete',
    caipanList: '/adminapi/caipan/caipanList',
    caipanDetail: '/adminapi/caipan/caipandetail',
    shengCpDetail: '/adminapi/caipan/shengCpDetail',
    shengCpDelete: '/adminapi/caipan/shengCpDelete',
    caipanEdit: '/adminapi/caipan/caipanedit',
    shengCpEdit: '/adminapi/caipan/shengCpEdit',
    caipanDelete: '/adminapi/caipan/caipandelete',


    guoapplydetail: '/adminapi/caipan/guoapplydetail',
    guoApplyDelete: '/adminapi/caipan/guoApplyDelete',
    shengCaipanPrint: '/adminapi/caipan/shengCaipanPrint',
}

export default api
export function shengCaipanPrint(parameter) {
    return axios({
        url: api.shengCaipanPrint,
        method: 'get',
        params: parameter
    })
}

export function getOptions(parameter) {
    return axios({
        url: api.options,
        method: 'get',
        params: parameter
    })
}
export function getApplyList(parameter) {
    return axios({
        url: api.getApplyList,
        method: 'get',
        params: parameter
    })
}
export function getGuoApplyList(parameter) {
    return axios({
        url: api.getGuoApplyList,
        method: 'get',
        params: parameter
    })
}

export function getCaipanList(parameter) {
    return axios({
        url: api.caipanList,
        method: 'get',
        params: parameter
    })
}
export function getMemberList(parameter) {
    return axios({
        url: api.getMemberList,
        method: 'get',
        params: parameter
    })
}
export function refreshCert(parameter) {
    return axios({
        url: api.refreshCert,
        method: 'get',
        params: parameter
    })
}

export function getGuoMemberList(parameter) {
    return axios({
        url: api.getGuoMemberList,
        method: 'get',
        params: parameter
    })
}

export function getCaipanDetail(parameter) {
    return axios({
        url: api.caipanDetail,
        method: 'get',
        params: parameter
    })
}
export function getShengCaipanDetail(parameter) {
    return axios({
        url: api.shengCpDetail,
        method: 'get',
        params: parameter
    })
}
export function checkShengMemberOK(parameter) {
    return axios({
        url: api.checkShengMemberOK,
        method: 'get',
        params: parameter
    })
}

export function checkGuoMemberOK(parameter) {
    return axios({
        url: api.checkGuoMemberOK,
        method: 'get',
        params: parameter
    })
}

export function editCaipan(parameter) {
    return axios({
        url: api.caipanEdit,
        method: 'post',
        data: parameter
    })
}

export function editShengCaipan(parameter) {
    return axios({
        url: api.shengCpEdit,
        method: 'post',
        data: parameter
    })
}
export function editShengCpManage(parameter) {
    return axios({
        url: api.manageEdit,
        method: 'post',
        data: parameter
    })
}
export function shengcpApply(parameter) {
    return axios({
        url: api.shengcpApply,
        method: 'post',
        data: parameter
    })
}
export function getShengShenheUrls(parameter) {
    return axios({
        url: api.getShengShenheUrls,
        method: 'post',
        data: parameter
    })
}
export function getShengApplyDetail(parameter) {
    return axios({
        url: api.shengapplydetail,
        method: 'post',
        data: parameter
    })
}
export function shengApplyDelete(parameter) {
    return axios({
        url: api.shengApplyDelete,
        method: 'get',
        params: parameter
    })
}

export function deleteCaipan(parameter) {
    return axios({
        url: api.caipanDelete,
        method: 'post',
        data: parameter
    })
}

export function deleteShengCp(parameter) {
    return axios({
        url: api.shengCpDelete,
        method: 'post',
        data: parameter
    })
}



export function guocpApply(parameter) {
    return axios({
        url: api.guocpApply,
        method: 'post',
        data: parameter
    })
}
export function getGuoShenheUrls(parameter) {
    return axios({
        url: api.getGuoShenheUrls,
        method: 'post',
        data: parameter
    })
}
export function getGuoApplyDetail(parameter) {
    return axios({
        url: api.guoapplydetail,
        method: 'post',
        data: parameter
    })
}
export function guoApplyDelete(parameter) {
    return axios({
        url: api.guoApplyDelete,
        method: 'get',
        params: parameter
    })
}